// 7. Fejlesztési prioritások
export const FEJLESZTESI_PRIORITASOK_OPTIONS = {
    hu: [
    { value: 'tananyagok_korszerusitese', label: 'Tananyagok korszerűsítése' },
    { value: 'modszertan_fejlesztese', label: 'Oktatásmódszertan fejlesztése' },
    { value: 'tantargyak_osszehangolasa', label: 'Tantárgyak összehangolása' },
    { value: 'kapacitas_javitasa', label: 'Oktatói kapacitás javítása' },
    { value: 'egyuttmukodes_erositese', label: 'Tanszéki együttműködés erősítése' },
    { value: 'tamogatas_fejlesztese', label: 'Hallgatói támogatás fejlesztése' },
    { value: 'nemzetkoziesites', label: 'Nemzetköziesítés' },
    { value: 'kapcsolatok_erositese', label: 'Ipari kapcsolatok erősítése' },
    { value: 'mutatok_javitasa', label: 'Mobilitási mutatók javítása' },
    { value: 'adatminoseg_fejlesztese', label: 'Adatminőség és információkezelés fejlesztése' }
    ],
    en: [
    { value: 'tananyagok_korszerusitese', label: 'Modernization of teaching materials' },
    { value: 'modszertan_fejlesztese', label: 'Development of teaching methodologies' },
    { value: 'tantargyak_osszehangolasa', label: 'Alignment of courses' },
    { value: 'kapacitas_javitasa', label: 'Improvement of teaching staff capacity' },
    { value: 'egyuttmukodes_erositese', label: 'Strengthening of departmental cooperation' },
    { value: 'tamogatas_fejlesztese', label: 'Development of student support services' },
    { value: 'nemzetkoziesites', label: 'Internationalisation' },
    { value: 'kapcsolatok_erositese', label: 'Strengthening of industry partnerships' },
    { value: 'mutatok_javitasa', label: 'Improvement of mobility indicators' },
    { value: 'adatminoseg_fejlesztese', label: 'Development of data quality and information management' }
    ]
};